import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ISortBy } from "../../types";

export interface CustomerState {
  id: number;
  phone?: string;
  account_plans: {
    id: number;
    expires: string;
    plan: {
      id: number;
      name: string;
    };
    plans_id: number;
    status: "active" | "canceled";
    passed: boolean | null;
  };
  countries_id: number;
  country: {
    id: number;
    name: string;
  };
  email: string;
  joined: string;
  name: string;
  billing_histories: {
    accounts_id: number;
    total: string;
  };
  account_notes: {
    note: string | null;
  };
  account_agreements: {
    status: string | null;
  };
  account_flags: {
    flag: string | null;
  };
  status?: number;
  index_row: number;
  stateprov: string;
  free_reset: number;
  last4: string;
  banned_accounts: null | { id: number };
  address: string | null;
  account_category?: string;
}

export type TBy =
  | "id"
  | "name"
  | "email"
  | "joined_after"
  | "joined_before"
  | "expires_after"
  | "expires_before"
  | "country"
  | "plan_name"
  | "note"
  | "flag"
  | "status"
  | "compare_total"
  | "primaryLanguage"
  | "last4"
  | "total";

export interface CustomersData {
  accounts: CustomerState[];
  allAccounts: CustomerState[];
  count: number;
}

export type TSortParams = ISortBy<TBy>;

export interface CustomersState {
  data: CustomersData;
  loading: boolean;
}

const initialState: CustomersState = {
  data: {
    accounts: [],
    allAccounts: [],
    count: 0,
  },
  loading: false,
};

const index = createSlice({
  name: "customers",
  initialState,
  reducers: {
    fetchRequest: (state) => {
      state.loading = true;
    },
    fetchSuccess: (
      state,
      action: PayloadAction<{
        customers: CustomersData;
        sortParams: TSortParams;
      }>
    ) => {
      state.data.count = action.payload.customers.count;
      state.data.accounts = action.payload.customers.accounts;
      state.loading = false;
    },
    fetchFailed: (state) => {
      state.loading = false;
    },
    // All customers
    fetchAllCustomersRequest: (state) => {
      state.loading = true;
    },
    fetchAllCustomersSuccess: (state, action: PayloadAction<{ customers: CustomerState[] }>) => {
      state.loading = false;
      state.data.allAccounts = action.payload.customers;
    },
    fetchAllCustomersFailed: (state) => {
      state.loading = false;
    },
  },
});

export const customersActions = index.actions;
export default index.reducer;
